import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import getScrollbarSize from '../../../utils/get-scrollbar-size.esm.js';
import Box from '../../_primitives/box/box.esm.js';

var _excluded = ["variant", "className", "anchorRect", "dropdownRect", "isTop", "borderShadowEclipseThickness"];
var Adorner = function Adorner(props) {
  var variant = props.variant,
    className = props.className,
    anchorRect = props.anchorRect,
    dropdownRect = props.dropdownRect,
    isTop = props.isTop,
    borderShadowEclipseThickness = props.borderShadowEclipseThickness,
    rest = _objectWithoutProperties(props, _excluded);

  /* eslint-disable */
  var styleOverrides = useMemo(function () {
    if (dropdownRect && anchorRect) {
      var _window$getComputedSt, _window$getComputedSt2, _window$getComputedSt3;
      var left = dropdownRect.left > anchorRect.left ? dropdownRect.left + 1 : anchorRect.left + 1;

      //if there is a scrollbar gutter on the left, be sure to account for that and shift adorner
      if ((_window$getComputedSt = (_window$getComputedSt2 = window.getComputedStyle(document.documentElement)) === null || _window$getComputedSt2 === void 0 ? void 0 : (_window$getComputedSt3 = _window$getComputedSt2.scrollbarGutter) === null || _window$getComputedSt3 === void 0 ? void 0 : _window$getComputedSt3.includes('both-edges')) !== null && _window$getComputedSt !== void 0 ? _window$getComputedSt : false) {
        var scrollbarWidth = getScrollbarSize();
        left -= scrollbarWidth;
      }
      return {
        top: isTop ? dropdownRect.bottom : dropdownRect.top,
        left: left,
        width: dropdownRect.left > anchorRect.left && dropdownRect.right > anchorRect.right ? anchorRect.right - dropdownRect.left - 2 : Math.min(anchorRect.width - 2, dropdownRect.width - 2)
      };
    } else {
      return undefined;
    }
  }, [isTop, dropdownRect && anchorRect, dropdownRect === null || dropdownRect === void 0 ? void 0 : dropdownRect.bottom, dropdownRect === null || dropdownRect === void 0 ? void 0 : dropdownRect.top, dropdownRect === null || dropdownRect === void 0 ? void 0 : dropdownRect.left, anchorRect === null || anchorRect === void 0 ? void 0 : anchorRect.left, dropdownRect === null || dropdownRect === void 0 ? void 0 : dropdownRect.right, anchorRect === null || anchorRect === void 0 ? void 0 : anchorRect.right, anchorRect === null || anchorRect === void 0 ? void 0 : anchorRect.width, dropdownRect === null || dropdownRect === void 0 ? void 0 : dropdownRect.width]);
  /* eslint-enable */

  var sxOverrides = useMemo(function () {
    return _objectSpread2({
      transform: "translate(0px,".concat(isTop ? -1 : -(borderShadowEclipseThickness - 1), "px)")
    }, isTop ? {
      borderTop: 'mediumGray'
    } : {
      borderBottom: 'mediumGray'
    });
  }, [isTop, borderShadowEclipseThickness]);
  if (!anchorRect || !dropdownRect) {
    return null;
  }

  // eslint-disable-next-line no-console
  // console.log(`render Adorner isTop: ${isTop}`)
  return !(variant === 'primary' || variant !== null && variant !== void 0 && variant.includes('ghost')) ? /*#__PURE__*/React.createElement(Box, _extends({
    className: classNames('csg-tui-popover-adorner', className),
    absolute: true,
    height: "".concat(borderShadowEclipseThickness, "px"),
    zIndex: "selectButton",
    bg: "white",
    sx: sxOverrides,
    style: styleOverrides
  }, rest)) : null;
};

export default Adorner;
//# sourceMappingURL=adorner.esm.js.map
